var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4C10.6739 4 9.40215 4.52678 8.46447 5.46447C7.52678 6.40215 7 7.67392 7 9C7 9.26522 7.10536 9.51957 7.29289 9.70711C7.48043 9.89464 7.73478 10 8 10C8.26522 10 8.51957 9.89464 8.70711 9.70711C8.89464 9.51957 9 9.26522 9 9C9 7.342 10.342 6 12 6C13.658 6 15 7.342 15 9C15 9.816 14.801 10.294 14.562 10.629C14.3 10.994 13.937 11.267 13.434 11.614L13.318 11.692C12.871 11.998 12.295 12.391 11.849 12.939C11.322 13.587 11 14.406 11 15.5V16C11 16.2652 11.1054 16.5196 11.2929 16.7071C11.4804 16.8946 11.7348 17 12 17C12.2652 17 12.5196 16.8946 12.7071 16.7071C12.8946 16.5196 13 16.2652 13 16V15.5C13 14.844 13.178 14.476 13.4 14.201C13.657 13.887 14.003 13.649 14.514 13.298L14.567 13.261C15.063 12.921 15.7 12.475 16.187 11.793C16.7 11.081 17 10.183 17 9C17 7.67392 16.4732 6.40215 15.5355 5.46447C14.5979 4.52678 13.3261 4 12 4ZM12 21.25C12.3315 21.25 12.6495 21.1183 12.8839 20.8839C13.1183 20.6495 13.25 20.3315 13.25 20C13.25 19.6685 13.1183 19.3505 12.8839 19.1161C12.6495 18.8817 12.3315 18.75 12 18.75C11.6685 18.75 11.3505 18.8817 11.1161 19.1161C10.8817 19.3505 10.75 19.6685 10.75 20C10.75 20.3315 10.8817 20.6495 11.1161 20.8839C11.3505 21.1183 11.6685 21.25 12 21.25Z",
    fill: "#070707"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.f6c9fac53a3f579cab6857418c2c3b15.svg";
export { ForwardRef as ReactComponent };